// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContractorNotificationsController from "./contractor_notifications_controller"
application.register("contractor-notifications", ContractorNotificationsController)

import DroneProjectFormController from "./drone_project_form_controller"
application.register("drone-project-form", DroneProjectFormController)

import GoogleAdsConversionController from "./google_ads_conversion_controller"
application.register("google-ads-conversion", GoogleAdsConversionController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LocalTimezoneController from "./local_timezone_controller"
application.register("local-timezone", LocalTimezoneController)

import MarketingController from "./marketing_controller"
application.register("marketing", MarketingController)

import ProjectIntakeController from "./project_intake_controller"
application.register("project-intake", ProjectIntakeController)

import QuickProjectController from "./quick_project_controller"
application.register("quick-project", QuickProjectController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ThemeVideoController from "./theme_video_controller"
application.register("theme-video", ThemeVideoController)

import StuckRefreshController from "./stuck_refresh_controller"
application.register("stuck-refresh", StuckRefreshController)
